
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconInformationCircle = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0zm.25 5a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm2.25 13.5h-4a1 1 0 0 1 0-2h.75a.25.25 0 0 0 .25-.25v-4.5a.25.25 0 0 0-.25-.25h-.75a1 1 0 0 1 0-2h1a2 2 0 0 1 2 2v4.75a.25.25 0 0 0 .25.25h.75a1 1 0 1 1 0 2z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 23.501c-6.341 0-11.5-5.159-11.5-11.5S5.659.501 12 .501s11.5 5.159 11.5 11.5-5.159 11.5-11.5 11.5zm0-22c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5z' }),
    React.createElement('path', { d: 'M13 17.505c-.827 0-1.5-.673-1.5-1.5v-6.5H10a.5.5 0 0 1 0-1h1.5c.551 0 1 .449 1 1v6.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 1 0 1H13zM11.745 7.5a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M13.5 17.25A2.252 2.252 0 0 1 11.25 15v-3.75h-.75a.75.75 0 0 1 0-1.5h.75c.827 0 1.5.673 1.5 1.5V15c0 .414.336.75.75.75h.75a.75.75 0 0 1 0 1.5h-.75z' }),
    React.createElement('circle', { cx: '11.625', cy: '7.125', r: '1.125' }),
    React.createElement('path', { d: 'M12 24C5.383 24 0 18.617 0 12S5.383 0 12 0s12 5.383 12 12-5.383 12-12 12zm0-22.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12 17.79 1.5 12 1.5z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconInformationCircle.displayName = 'IconInformationCircle';
export default IconInformationCircle;